import axios from "axios";

export default {
    getSetupData: async (companyId, appId) => {
        // TODO: post for something that should be get. Currently all features have their own shared endpoint
        // Did not create a separate endpoint for this but something to think about
        const { data } = await axios.post(`/a/${companyId}/features/${appId}/setup_data`)

        return data
    }
}
